export const LOCATION_CREATE_REQUEST = "@locations.create.request";
export const LOCATION_CREATE_SUCCESS = "@locations.create.success";
export const LOCATION_CREATE_FAIL = "@locations.create.failure";
export const LOCATION_CREATE_DONE = "@locations.create.done";
